import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { MsalProvider } from '@azure/msal-react'
import App from './App'
import { ErrorBoundary } from './components/common/ErrorBoundary'
import { msalInstance } from './auth/msalInstance'
import { msalConfigured } from './auth/msalConfig'
import './styles/globals.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 2,
    },
  },
})

async function bootstrap() {
  if (msalConfigured) {
    await msalInstance.initialize()
    // Handle redirect response from Entra ID (returns null if not a redirect).
    await msalInstance.handleRedirectPromise()
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
      msalInstance.setActiveAccount(accounts[0])
    }
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <MsalProvider instance={msalInstance}>
              <App />
            </MsalProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </StrictMode>,
  )
}

bootstrap().catch((err) => {
  console.error('MSAL bootstrap failed:', err)
})

